function game_5001()
{

}

game_5001.odd_map  = {
  "A":[0,0,30,125,500],
  "B":[0,0,20,100,250],
  "C":[0,0,20,80,200],
  "D":[0,0,15,75,150],
  "E":[0,0,15,60,150],
  "F":[0,0,10,30,125],
  "G":[0,0,8,25,120],
  "H":[0,0,5,20,100],
  "I":[0,0,2,15,80],
};

export {
  game_5001
};



// WEBPACK FOOTER //
// ./src/components/slots/game_5001.js